module.exports = __webpack_public_path__ + "static/media/sfyg-system.ab81b60b.png";